/**
 * Vista virtual "solo nodos sin carpeta asignada" (no es un UUID de carpeta).
 */
export const UNFILED_FOLDER_SENTINEL = '__unfiled__' as const

export function isUnfiledFolderView(activeFolderId: string | null): boolean {
  return activeFolderId === UNFILED_FOLDER_SENTINEL
}

export function filterNodesByFolderView<T extends { folderId?: string | null }>(
  nodes: T[],
  activeFolderId: string | null
): T[] {
  if (activeFolderId === null) return nodes
  if (activeFolderId === UNFILED_FOLDER_SENTINEL) {
    return nodes.filter((n) => n.folderId == null || n.folderId === '')
  }
  return nodes.filter((n) => n.folderId === activeFolderId)
}
